import Video from 'react-scale/components/pages/homepage/hero/video';
import { CTA } from 'react-scale/components';
import styles from './text-rotation.module.css';

const Hero = () => (
  <section className="relative pt-0 text-white md:pb-8 sm:py-10 sm:h-3/4 ">
    <div className="container grid md:grid-cols-3">
      <div className="relative z-10 col-span-2">
        <h1 className="pt-8 text-6xl font-light leading-none -translate-x-1 lg:-translate-x-2 md:pt-16 lg:text-9xl font-aeonik">
          <span className="text-transform-gradient">Better Data.</span>

          <div className="h-24 mt-6 md:mt-4 md:h-32">
            <div className={styles.cubespinner}>
              <div className={styles.face1}>Better AI.</div>
              <div className={styles.face2}>Faster AI.</div>
              <div className={styles.face3}>Scalable AI.</div>
            </div>
          </div>
        </h1>
        <p className="mb-10 text-base leading-normal lg:pr-12 lg:mt-12 lg:text-lg md:w-11/12 lg:mb-14">
          Better data leads to more performant models. Performant models lead to faster deployment.
          Deliver value from your AI investments faster with better data.
        </p>
        <div
          className="w-full mb-16 md:w-2/3 md:flex-row md:space-x-4 md:mb-0"
          style={{ minHeight: 134 }}
        >
          <CTA />
        </div>
      </div>
      <div className="absolute inset-0 transform -translate-x-12 md:relative md:col-span-1 md:translate-x-0">
        <div
          className="absolute z-0 transform -translate-y-40 left-1/2 md:left-0 -translate-x-2/4 md:-translate-x-96"
          style={{ width: '1000px', height: '800px' }}
        >
          <Video />
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
